import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { convertTo12HourFormat } from "../../common-data/Converts";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
import { sortShiftsByStartTime } from "./SortShifts";
import { fetchReceptionistShiftsData } from "../../../redux/reducers/dropdownApiSlice";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";

const ShiftManagement = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
  mainCallback,
}) => {
  const dispatch = useDispatch();
  const { postPutLoadingFormData } = useSelector((state) => state.common);
  const { receptionistShifts } = useSelector((state) => state.dropdown);

  const accountType = rowData?.account_type;

  const forminitials = {
    staffName: rowData?.name ? rowData.name : "",
    staffMobile: rowData?.mobile ? rowData.mobile : "",
    staffEmail: rowData?.email ? rowData.email : "",

    checkedShifts:
      rowData?.checkedShifts?.length > 0 ? [...rowData.checkedShifts] : [],
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  function getReceptionistShifts() {
    const filters = {
      page: 1,
      limit: 1000,
      status: "active",
    };

    dispatch(
      fetchReceptionistShiftsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => {
      if (type === "checkbox") {
        const updatedShifts = checked
          ? [...prev.checkedShifts, value]
          : prev.checkedShifts.filter((shift) => shift !== value);

        return {
          ...prev,
          checkedShifts: updatedShifts,
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (
      (accountType === "receptionist" ||
        accountType === "sales_manager" ||
        rowData?.is_cluster_manager) &&
      formValues.checkedShifts?.length === 0
    )
      errors.checkedShifts = "Required!";

    return errors;
  };

  const handleShiftFormUpdate = async (userData) => {
    const method = "PUT";
    const endpoint = "/user/receptionist";
    const token = userInfoData?.token || "";

    const formData = new FormData();
    for (const key in userData) {
      if (userData.hasOwnProperty(key)) {
        if (userData[key] instanceof File) {
          formData.append(key, userData[key]);
        } else {
          formData.append(key, userData[key].toString());
        }
      }
    }

    const requestBody = formData;

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        closeModal();
        if (typeof mainCallback === "function") {
          mainCallback();
        }
        toast.success(
          result?.payload?.message || "Shift timing updated successfully!"
        );
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        uid: rowData?.receptionist_uid || "",
        name: rowData?.name || "",
        shift_id: formValues.checkedShifts?.toString() || "",
      };

      const handleConfirm = async () => {
        handleShiftFormUpdate(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Do you want to update the details of ${rowData?.name}?`,
        "Cancel",
        "Update"
      );
    }
  };

  useEffect(() => {
    getReceptionistShifts();
  }, []);

  console.log("formErrors=> ", formErrors);

  return (
    <>
      <div className="form-container mb30">
        <form className="formContainer">
          <div className="formInputsGrid twoGridSystem mb30">
            {/* <div className="formInputBox">
              <label htmlFor="staffName" className={`formInputLabel`}>
                {accountType?.replace(/_/g, " ")} Name
              </label>

              <input
                type="text"
                placeholder="Enter Full Name"
                className={`formInput ${
                  formErrors?.staffName ? "formError" : ""
                }`}
                name="staffName"
                value={formValues.staffName}
                disabled
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="staffMobile" className={`formInputLabel`}>
                mobile number
              </label>

              <input
                type="number"
                placeholder="Enter Mobile Number"
                className={`formInput ${
                  formErrors?.staffMobile ? "formError" : ""
                }`}
                name="staffMobile"
                value={formValues.staffMobile}
                disabled
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="staffEmail" className={`formInputLabel`}>
                email address
              </label>

              <input
                type="email"
                placeholder="Enter Email Address"
                className={`formInput ${
                  formErrors?.staffEmail ? "formError" : ""
                }`}
                name="staffEmail"
                value={formValues.staffEmail}
                disabled
              />
            </div> */}

            <div className="formInputBox checkbox-wrapper span2">
              <label htmlFor="checkedShifts" className="formInputLabel">
                choose shift time <span className="required">*</span>
              </label>

              <div
                className={`flex-box ${
                  formErrors?.checkedShifts ? "formError" : ""
                }`}
                style={{ borderRadius: "10px" }}
              >
                {(() => {
                  try {
                    const sortedShifts =
                      sortShiftsByStartTime(receptionistShifts);

                    if (sortedShifts.length === 0) {
                      return <span className="info">No shifts available</span>;
                    }

                    return sortedShifts.map((shift, index) => {
                      const isChecked = Array.isArray(formValues?.checkedShifts)
                        ? formValues.checkedShifts.includes(shift?.value)
                        : false;

                      return (
                        <label
                          className={`checkboxLabel ${
                            isChecked ? "active" : ""
                          }`}
                          key={shift?.value || index}
                        >
                          <input
                            type="checkbox"
                            name="checkedShifts"
                            value={shift?.value || ""}
                            checked={isChecked}
                            onChange={onChangeInput}
                          />
                          {shift?.label || "Unknown Shift"}
                        </label>
                      );
                    });
                  } catch (error) {
                    console.error("Error rendering shifts:", error);
                    return <span className="info">Error loading shifts</span>;
                  }
                })()}
              </div>
            </div>

            {rowData?.shift_details &&
              Array.isArray(rowData.shift_details) &&
              rowData.shift_details.length > 0 && (
                <div className="current-shift-times span2">
                  {(() => {
                    try {
                      const validShifts = rowData.shift_details.filter(
                        (shift) =>
                          shift &&
                          typeof shift === "object" &&
                          shift.shift_start &&
                          shift.shift_end &&
                          shift.shift_start !== null &&
                          shift.shift_end !== null &&
                          shift.shift_start.trim() !== "" &&
                          shift.shift_end.trim() !== ""
                      );

                      if (validShifts.length === 0) {
                        return null;
                      }

                      const sortedCurrentShifts = validShifts.sort((a, b) => {
                        const getTimeInMinutes = (timeStr) => {
                          if (!timeStr || typeof timeStr !== "string") return 0;
                          const [hours, minutes] = timeStr
                            .split(":")
                            .map(Number);
                          return isNaN(hours) || isNaN(minutes)
                            ? 0
                            : hours * 60 + minutes;
                        };

                        const timeA = getTimeInMinutes(a.shift_start);
                        const timeB = getTimeInMinutes(b.shift_start);
                        return timeA - timeB;
                      });

                      return (
                        <div className="current-shift-timing">
                          <div className="current-shift-label">
                            Current Shift Timing:
                            {sortedCurrentShifts.length > 1 && (
                              <span className="shift-count">
                                ({sortedCurrentShifts.length} shifts)
                              </span>
                            )}
                          </div>
                          <div className="current-shift-times">
                            {sortedCurrentShifts.map((shift, index) => {
                              const startTime = convertTo12HourFormat(
                                shift?.shift_start
                              );
                              const endTime = convertTo12HourFormat(
                                shift?.shift_end
                              );

                              return (
                                <div key={index} className="shift-time-display">
                                  <span className="shift-time-range">
                                    {startTime} - {endTime}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    } catch (error) {
                      console.error("Error processing current shifts:", error);
                      return null;
                    }
                  })()}
                </div>
              )}
          </div>

          <CloseSubmitBtn
            closeLabel="Cancel"
            submitLabel={"Update"}
            onClose={closeModal}
            onSubmit={onSubmit}
            isLoading={postPutLoadingFormData}
          />
        </form>
      </div>
    </>
  );
};

export default ShiftManagement;
